export var DEFAULT_APPEARANCE = 'normal';
export var VAR_COLOR = '--color';
export var VAR_BG_COLOR = '--bg-color';
export var VAR_BG_COLOR_HOVER = '--bg-color-hover';
export var VAR_BG_COLOR_ACTIVE = '--bg-color-active';